import { AfterContentInit, Component, Input, OnInit } from '@angular/core';
import { NgxConfigureService } from 'ngx-configure';
import { AuthenticationService } from '../../services/authentication.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ServerMetadataService } from '../../services/server-metadata.service';
import { ConfigurationService } from '../../services';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Role } from '../../models/role';
import { initApplicationSelector } from '../../store/Application/ApplicationSelector';
import { Store } from '@ngrx/store';
import { ApplicationState } from '../../store/Application/ApplicationReducer';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, AfterContentInit {

  @Input()
  bsModalRef: BsModalRef;

  newPasswordRequired = false;

  public config: any;

  username: string;
  password: string;

  newPassword: string;
  confirmNewPassword: string;

  isReadOnly = true;

  isProtocolsMatch: boolean;

  constructor(
    configService: NgxConfigureService,
    private authenticationService: AuthenticationService,
    private readonly router: Router,
    private toastr: ToastrService,
    private readonly applicationStore: Store<ApplicationState>,
    private protocolService: ServerMetadataService,
    private configurationService: ConfigurationService,
    private translate: TranslateService
  ) {
    this.config = configService.config;
  }

  showSuccess()  {
    this.toastr.success('Success!!', 'This is a success alert.');
  }
  showWarning()  {
    this.toastr.warning('Warning!', 'This is a warning alert.');
  }
  showError(err)  {
    this.toastr.error(err, 'Error!');
  }
  showInfo()  {
    this.toastr.info('Info', 'This is a info alert.');
  }

  // Auto focus input field
  inputFocus() {
    const usernameField = document.getElementById('username');
    if (usernameField) {
      usernameField.focus();
    }
  }

  inputFocusTimed() {
    setTimeout(() => {
      this.inputFocus();
    }, 100);
  }



  ngOnInit() {
    this.applicationStore.select(initApplicationSelector).subscribe((config) => {
      this.isProtocolsMatch = config.version === this.configurationService.getProtocolVersion();
    });

    setTimeout(() => {
      this.isReadOnly = false;
    }, 1000);

    // this.showSuccess();
    // setTimeout(()=>{
    //   this.showInfo();
    // }, 1000);
    //
    // setTimeout(()=>{
    //   this.showWarning();
    // }, 2000);
    //
    // setTimeout(()=>{
    //   this.showError();
    // }, 3000);

  }

  login() {
    let command;
    if (this.newPasswordRequired) {
      command = {
        username: this.username,
        password: this.password,
        newPassword: this.newPassword,
        confirmNewPassword: this.confirmNewPassword
      };
    } else {
      command = {
        username: this.username,
        password: this.password
      };
    }
    this.authenticationService.login(command).subscribe((response: any) => {
      localStorage.setItem('currentUser', JSON.stringify(response));
      this.bsModalRef.hide();
      if (response.user.role === Role.RL_ADMIN) {
        this.router.navigateByUrl('admin/currency-management');
      } else {
        this.router.navigateByUrl('home');
      }

      }, (error) => {
        if (error.error === 'errorNewPasswordRequired') {
          this.newPasswordRequired = true;
        }
        this.showError(this.translate.instant(error.error));
      },
    );
  }

  ngAfterContentInit() {
    this.inputFocusTimed();
  }
}
